import { useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import MenuCategoryList from "./MenuCathlog";
import ProductSearchList from "../../../constants/ProductSearchList";
import { SearchIcon, XIcon } from "../../../constants/Icons";

const AddProductSearch = ({
  onClose,
  //   onAdd,
  //   isBtnLoading,
  productSearchTerm,
  setProductSearchTerm,
  handleProductSearch,
  productSuggestions,
  handleSelectProduct,
  handleProductKeyDown,
  showProductDropdown,
  setShowProductDropdown,
  highlightedIndex,
  setHighlightedIndex,
  catalogItems = [],
}) => {
  const suggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);

  const stopEventPropagation = (e) => e.stopPropagation();

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div>
      <div className="modal-backdrop show" onClick={onClose}></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
          // style={{
          //   maxHeight: "95vh",
          //   minHeight: "40vh",
          //   height: "auto",
          // }}
          onClick={stopEventPropagation}
        >
          <div
            className="modal-content"
            // style={{
            //   display: "flex",
            //   flexDirection: "column",
            //   height: "100%",
            // }}
          >
            <div className="modal-header">
              <h6 className="modal-title">Add Product</h6>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body bg-light">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-sm-12" style={{ position: "relative" }}>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="search"
                          ref={suggestionsRef}
                          value={productSearchTerm}
                          autoComplete="off"
                          onChange={(e) => {
                            const value = e.target.value;

                            setProductSearchTerm(value); // ✅ works now
                            handleProductSearch(value);

                            setShowProductDropdown(true);
                            setHighlightedIndex(0);
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              productSuggestions[highlightedIndex]
                            ) {
                              handleSelectProduct(
                                productSuggestions[highlightedIndex],
                                true,
                              );
                            } else {
                              handleProductKeyDown(e);
                            }
                          }}
                          onFocus={() => {
                            if (productSuggestions.length > 0) {
                              setShowProductDropdown(true);
                            }
                          }}
                          placeholder="Search products by hsnsac, title..."
                          autoFocus
                        />
                        <button className="input-group-text">
                          <SearchIcon/>
                        </button>
                      </div>
                      {productSearchTerm && productSuggestions.length === 0 && (
                        <ul className="suggestions-list">
                          <li className="suggestion-item text-muted">
                            No products data was found
                          </li>
                        </ul>
                      )}
                      {showProductDropdown && productSuggestions.length > 0 && (
                        <ProductSearchList 
                          suggest={productSuggestions}
                          suggestionRefs={suggestionRefs}
                          handleSelect={handleSelectProduct}
                          activeIndex={highlightedIndex}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <MenuCategoryList
                items={catalogItems}
                onItemClick={
                  (productid) => handleSelectProduct({ _id: productid }, true) // ✅ use _id, not id
                }
              />
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductSearch;
